module.exports = __webpack_public_path__ + "img/shortcut-kimchi-fried-rice.ad755b28.jpg";